import { useMemo } from 'react'

import { useScreen } from '@/store/screen'

export const useFeaturedArticle = () => {
  const { windowSize } = useScreen()

  const fontSizesByScreenSize = useMemo(() => {
    const fontsSizesByScreen = {
      1440: {
        title: 'h4' as const,
      },
    }
    return fontsSizesByScreen
  }, [])

  const { width } = windowSize
  const fontSizes = useMemo(() => {
    if (!width) return fontSizesByScreenSize[1440]
    return fontSizesByScreenSize[1440]
  }, [width, fontSizesByScreenSize])

  return {
    fontSizes,
  }
}
